import React, { useContext, useEffect, useState } from "react";
import { AuthContext } from "../../hooks/context/authContext";
import { usePostRequest } from "../../hooks/usePostRequest/usePostRequest";
import {
  deleteFileFromS3API,
  downloadReporteFormacionProfesionalAPI,
  getAllCargosAPI,
  getRegionesAPI
} from "../../consumers/backendApisUrls";
import { mostrarMensajeDeErrorConToast, responseCode200 } from "../../consumers/httpRequiestsUtils";
import { downloadFile } from "../../consumers/backendConsumer";
import InputDate from "../../components/modalComponents/InputDate";
import InputSelect from "../../components/modalComponents/InputSelect";
import { useGetOptionsSelect } from "../../hooks/useGetOptionsSelect/useGetOptionsSelect";
import { handleFind, initialAllOptionPromises } from "../../helper/utils";
import { usePropsInputs } from "../../hooks/useProps/usePropsInput";
import { usePropsSelect } from "../../hooks/useProps/usePropsSelect";
import { useSubmitForm } from "../../hooks/useSubmitForm/useSubmitForm";

const ReporteFormacionProfesional = () => {
  const SECTION_NAME = "ReporteFormacionProfesional";
  const INIT_KEYS = {
    departamentos: "IdDepartamento",
    cargos: "IdCargo",
    desde: "FechaInicio",
    hasta: "FechaFin",
  };
  const {state} = useContext(AuthContext);

  const [loading, setLoading] = useState(false);

  const [formValues, setFormValues] = useState({});
  const [allDropdowns, setAllDropdowns] = useState([]);
  const [commonProps] = usePropsInputs(formValues, setFormValues, SECTION_NAME);
  const [selectProps] = usePropsSelect(allDropdowns, formValues, setFormValues, SECTION_NAME);
  
  const [submitForm] = useSubmitForm();
  const [executePostRequest] = usePostRequest();
  const [getOptions] = useGetOptionsSelect();

  const initialPromises = () => {
    return [getOptions(getRegionesAPI()), getOptions(getAllCargosAPI())];
  }
  
  const descargarReporte = async () => {
    setLoading(true);
    try {
      const api = downloadReporteFormacionProfesionalAPI();
      let payload = formValues;
      await submitForm(
        Object.values(INIT_KEYS),
        api,
        payload,
        SECTION_NAME,
        successDescargarReporteCallback
      );
    } catch (error) {
      console.error(error);
    }
    setLoading(false);
  };
  
  const successDescargarReporteCallback = async (res) => {
    let data = res.data;
    let reporte = await downloadFile(state.token, data?.FilePath, data?.OriginalFileName);
    if(responseCode200(reporte)){
      await eliminarArchivoDeS3(data?.FilePath);
    } else {
      mostrarMensajeDeErrorConToast(reporte);
    }
  }

  const eliminarArchivoDeS3 = async function (filePath) {
    let deleteFileFromS3Payload = {
      Path: filePath,
    };
    let deleteFileFromS3Response = await executePostRequest(
      deleteFileFromS3API(),
      deleteFileFromS3Payload
    );
    if (responseCode200(deleteFileFromS3Response)) {
      console.debug("delete file from s3 successfully");
    } else {
      mostrarMensajeDeErrorConToast(deleteFileFromS3Response);
    }
  };
  
  const updateFormValues = (data) => {
    setAllDropdowns(data);
    const targetDepartamentos = handleFind(data, INIT_KEYS.departamentos);
    if (targetDepartamentos?.length === 1){
      const targetDepartamento = targetDepartamentos[0].value;
      setFormValues({ [INIT_KEYS.departamentos]: targetDepartamento })
    }
  }
  
  const init = async () => {
    await initialAllOptionPromises(initialPromises, Object.values(INIT_KEYS), updateFormValues);
  }
  
  useEffect(() => {
    init();
  }, [])

  return (
    <>
      <div className="card-body">
        <div id={SECTION_NAME}>
          <Div>
            <InputDate
              label="Fecha Inicio"
              {...commonProps(INIT_KEYS.desde)}
              isRequired
              toolTipText="Fecha cuando se registró/modificó la formación profesional"
            />
          </Div>
          <Div>
            <InputDate
              label="Fecha Fin"
              {...commonProps(INIT_KEYS.hasta)}
              isRequired
              toolTipText="Fecha cuando se registró/modificó la formación profesional"
            />
          </Div>
          <Div>
            <InputSelect
              label="Región"
              {...selectProps(INIT_KEYS.departamentos, [])}
            />
          </Div>
          <Div>
            <InputSelect label="Cargo" {...selectProps(INIT_KEYS.cargos, [])} />
          </Div>
          <div className="reporte-datos-generales-dato-obligatorio">
            <p>
              (<span className="required ">*</span>) Dato obligatorio
            </p>
          </div>
          <p className="reporte-asignacion-familiar-text">
            Este reporte contiene a los Colaboradores activos de Innova con los
            datos de su formación profesional (sin incluir postgrado).
          </p>
          <div>
            <button
              className="btn btn-primary generic-button-ficha reportes-descargar-button"
              onClick={descargarReporte}>
              {loading ? "Descargando" : "Descargar"} Reporte{" "}
              {loading ? "..." : ""}
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default ReporteFormacionProfesional;

const Div = ({ children }) => <div className="col-sm-6">{children}</div>;